/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable unicorn/prefer-query-selector */
import { PageLoading } from './components/PageLoading';
import { PageNotFound } from './components/PageNotFound';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';

import './i18n';

import * as React from 'react';
import { createRoot } from 'react-dom/client';

import { createRouter, ErrorComponent, RouterProvider } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';

import { Providers } from './Providers';
import { routeTree } from './routeTree.gen';
import * as Sentry from '@sentry/react';

ModuleRegistry.registerModules([AllCommunityModule]);

const router = createRouter({
  routeTree,
  defaultPendingComponent: () => <PageLoading />,
  defaultNotFoundComponent: () => <PageNotFound />,
  defaultErrorComponent: ({ error }) => <ErrorComponent error={error} />,
  defaultPreload: 'viewport',
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
});

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? import.meta.env.MODE,
  integrations: [Sentry.tanstackRouterBrowserTracingIntegration(router), Sentry.replayIntegration()],
  tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? '0.1'),
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
  enabled: import.meta.env.MODE !== 'development',
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const isDev = import.meta.env.MODE === 'development';

const rootElement = document.getElementById('app')!;
if (!rootElement.innerHTML) {
  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <Providers>
        <RouterProvider router={router} />
        {isDev && <TanStackRouterDevtools router={router} />}
      </Providers>
    </React.StrictMode>,
  );
}
